export const isIncluded = (
  list,
  { owner, flatId },
  keyFlat,
  ownerKey = 'owner'
) => list.findIndex(u => u[ownerKey] === owner && u[keyFlat] === flatId) >= 0
